<template>
  <section class="d-flex flex-row flex-wrap justify-content-between">
    <div class="d-flex flex-row">
      <h1>{{ bannerContent.titre.toUpperCase() }}</h1>
      <div class="align-self-center">{{ num }}</div>
    </div>
    <div class="align-self-center">
      <font-awesome-icon size="2x" :icon="bannerContent.icon"></font-awesome-icon>
    </div>
  </section>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  name: "Banner",
  props: {
    num: {
      type: Number
    }
  },
  data(){
    return{
      bannerContent: {}
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([
        'getMenu'
    ])
  },
  beforeCreate() {},
  created() {
    this.bannerContent = this.getMenu.filter((menu) => menu.path === this.$route.path.slice(1))[0]
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
  section{
    border-radius: 1rem;
    padding: .2rem .8rem;
    background-color: var(--color-chestnut-rose, rgba(212, 106, 106, 1));
    & > div:nth-child(1){
      & > h1{
        font-size: larger;
        color: var(--color-white, rgba(255, 255, 255, 1));
      }
      & > div{
        font-weight: bold;
        margin-left: 1rem;
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-black, rgba(0, 0, 0, 1));
        padding: .2rem;
        border-radius: .5rem;
      }
    }
    & > div:nth-child(2){
      color: var(--color-white, rgba(255, 255, 255, 1));
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/Banner.vue